import type { ReactNode } from "react";
import { Main } from "@/ui/layout/main";
import { AppHeaderBar } from "@/components/layout/app-header-bar";

export function PageFrame({
  title,
  crumb,
  trail,
  switcher,
  actions,
  footerStart,
  footerEnd,
  children,
}: {
  /** Screen-reader h1. */
  title: string;
  /** Overrides the breadcrumb title in the header. */
  crumb?: string;
  /** Replaces the whole header breadcrumb (e.g. a back button trail). */
  trail?: ReactNode;
  switcher: ReactNode;
  actions?: ReactNode;
  footerStart?: ReactNode;
  footerEnd?: ReactNode;
  children: ReactNode;
}) {
  const footer = footerStart || footerEnd;
  return (
    <>
      <AppHeaderBar current={crumb} trail={trail} />
      <Main fluid className="pb-4">
        <h1 className="sr-only">{title}</h1>
        <div className="flex flex-col gap-4 md:h-[calc(100svh-136px)]">
          <div className="flex items-center justify-between gap-3 max-md:flex-col max-md:items-stretch">
            <div className="min-w-0">{switcher}</div>
            {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2 max-md:justify-end">{actions}</div> : null}
          </div>
          <div className="-m-1 flex min-h-0 flex-1 [scrollbar-width:none] flex-col overflow-y-auto p-1">{children}</div>
          {footer ? (
            <footer className="mt-auto flex shrink-0 flex-wrap items-center justify-between gap-3 max-md:flex-col max-md:flex-nowrap max-md:items-stretch">
              <div className="flex items-center gap-2 max-md:min-w-0 max-md:overflow-x-auto max-md:[scrollbar-width:none]">
                {footerStart}
              </div>
              <div className="flex items-center gap-2 max-md:min-w-0">{footerEnd}</div>
            </footer>
          ) : null}
        </div>
      </Main>
    </>
  );
}
